'use client';
import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CarouselComponent = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const slides = [
    {
      id: 1,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-1-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-1-scaled.webp',
      title: 'Ready to Explore Vietnam?',
      offer: '₹1,35,000*',
      price: 'Book Now & Let the Adventure Begin!',
      
    },
    {
      id: 2,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-5-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-5-scaled.webp',
      title: 'Escape to Phu Quoc',
      offer: '₹1,35,000*',
      price: 'Reserve Your Island Getaway Now!',
      oldPrice: '₹3,00,000',
    },
   
    {
      id: 3,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-2-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-2-scaled.webp',
     title: 'Halong Bay Boat Rides',
 offer: '₹1,35,000*',
price: 'Cruise Through Vietnam’s Scenic Wonder!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 4,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Da-Nang-Package-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Da-Nang-Package-scaled.webp',
      title: 'Walk the Golden Bridge in Da Nang',
      offer: '₹1,35,000*',
      price: 'Book Your Tour Today!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 5,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Phu-Quoc-3N-4D-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Phu-Quoc-3N-4D-scaled.webp',
      title: 'Phu Quoc – Where Every View is a Postcard!',
 offer: '₹1,35,000*',
price: 'Book Now & Wake Up to Ocean Paradise!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 6,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Phu-Quoc-4N-5D-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Phu-Quoc-4N-5D-scaled.webp',
     title: 'Want Beach Bliss in Phu Quoc?',
 offer: '₹1,35,000*',
price: 'Book Your Island Escape Today!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 7,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Cambodia-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Cambodia-scaled.webp',
     title: 'Marvel at the Majesty of Angkor Wat!',
 offer: '₹1,35,000*',
price: 'Book Your Vietnam & Cambodia Escape Today!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 8,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Package-5N6D-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Package-5N6D-scaled.webp',
     title: 'Sunsets at West Lake Await!',
 offer: '₹1,35,000*',
price: 'Book Your Hanoi Day Tour Now!',
      oldPrice: '₹3,00,000',
    },
    {
      id: 9,
      desktopImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Hanoi-Package-scaled.webp',
      mobileImage: 'https://trip.saishishirtours.in/wp-content/uploads/2025/07/Hanoi-Package-scaled.webp',
     title: 'Ride the Rails to Hanois Heartbeat!',
 offer: '₹1,35,000*',
price: 'Experience Hanois Famous Train Street – Book Now!',
      oldPrice: '₹3,00,000',
    }
  ];

  return (
    <div className="hero-carousel position-relative">
      {/* Custom Styles */}
      <style jsx global>{`
        .hero-carousel {
          height: 100vh;
          overflow: hidden;
        }
        
        .carousel-indicators button {
          width: 10px !important;
          height: 10px !important;
          border-radius: 50% !important;
          margin: 0 5px !important;
          background-color: #0b4878 !important;
          border: none !important;
        }
        
        .carousel-indicators .active {
          background-color: #ff9f26 !important;
        }
        
        .carousel-control-prev,
        .carousel-control-next {
          width: 40px !important;
          height: 40px !important;
          background-color: rgba(255, 255, 255, 0.3) !important;
          border-radius: 50% !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          opacity: 1 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.3s ease !important;
        }
        
        .carousel-control-prev:hover,
        .carousel-control-next:hover {
          background-color: rgba(255, 255, 255, 0.5) !important;
        }
        
        .carousel-control-prev {
          left: 20px !important;
        }
        
        .carousel-control-next {
          right: 20px !important;
        }
        
        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          background-image: none !important;
          width: 24px !important;
          height: 24px !important;
        }
        
        .carousel-item {
          height: 100vh;
          background-color: #000;
        }
        
        .carousel-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .gradient-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50%;
          background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
          z-index: 1;
        }
        
        .hero-content {
          position: absolute;
          bottom: 7%;
          left: 0;
          right: 0;
          z-index: 2;
          color: white;
          text-align: center;
          padding: 0 15px;
        }
        
        .navbar-glass {
          background: rgba(0, 0, 0, 0.3) !important;
          backdrop-filter: blur(3px) !important;
        }
        
        @media (max-width: 767.98px) {
          .carousel-control-prev,
          .carousel-control-next {
            width: 30px !important;
            height: 30px !important;
          }
          
          .hero-content {
            bottom: 10%;
          }
          
          .offer-badge {
            font-size: 0.9rem !important;
            padding: 0.25rem 0.5rem !important;
          }
        }
      `}</style>

      <Carousel 
        activeIndex={index}
        onSelect={handleSelect}
        fade
        indicators
        nextIcon={
          <span aria-hidden="true">
            <ChevronRight size={24} color="white" />
          </span>
        }
        prevIcon={
          <span aria-hidden="true">
            <ChevronLeft size={24} color="white" />
          </span>
        }
        interval={3000}
        pause={false}
        wrap={true}          
  controls={true}       
  keyboard={true}       
  touch={true}
      >
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <img
              className="carousel-image"
              src={isMobile ? slide.mobileImage : slide.desktopImage}
              alt={slide.title}
              loading={slide.id === 1 ? 'eager' : 'lazy'}
            />
            
            <div className="gradient-overlay"></div>
            
            <div className="hero-content">
              <h2 className="display-4 fw-bold mb-3 text-shadow">{slide.title}</h2>
              <p className="h4 mb-3">
                Starting at{' '}
                <span className="offer-badge  text-white px-2 py-1 rounded " style={{ backgroundColor: '#ff9f26' }}>
                  {slide.offer}
                </span>
              </p>
              <p className="h5 mb-4">
                <span className="fw-bold">{slide.price}</span>
              </p>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselComponent;